import React from 'react'
import {Box} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {renderLayoutsSwitch} from '../../utils/contentRenderer'

const StandardPage = (content) => {
    let firstHeroFound = false
    return (
        <Box>
            {content?.MainContentArea?.map((block, contentIndex) => {
                const isHero =
                    !firstHeroFound && block.__typename === 'HeroBanner'
                if (isHero) firstHeroFound = true
                return (
                    <React.Fragment key={contentIndex}>
                        {renderLayoutsSwitch(block, {isHero})}
                    </React.Fragment>
                )
            })}
        </Box>
    )
}

StandardPage.displayName = 'StandardPage'

StandardPage.propTypes = {
    content: PropTypes.object
}

export default StandardPage
